import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  background: #f2f5fc;
  width: 100%;
  height: 100%;
  overflow: auto;

  /**
   * PWA instalado: em tablet a aplicação usa este layout (o layout mobile
   * só entra abaixo de 600px). Os recuos laterais evitam que a interface
   * fique sob o notch quando o aparelho está na horizontal.
   */
  @media (display-mode: standalone), (display-mode: fullscreen) {
    padding-top: var(--safe-top, 0px);
    padding-left: var(--safe-left, 0px);
    padding-right: var(--safe-right, 0px);
  }
`;

export const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  height: 100%;
  width: 100%;
  max-width: 2000px;
  padding: 0;
  /* overflow: auto; */

  /**
   * O padding vem das variáveis globais (styles/global.js) para que os
   * cálculos de altura das telas (var(--app-chrome-h)) acompanhem a
   * densidade aplicada em tablets / telas de baixa altura.
   */
  ${(props) =>
    props.withPadding &&
    css`
      padding: var(--app-content-pad-y) var(--app-content-pad-x);
    `}
`;

export const Footer = styled.footer`
  display: flex;
  justify-content: flex-end;
  padding: ${(props) => (props.isMobile ? '2px 10px 0' : '5px 0 0')};
  background: none;
  margin: auto 0 0;

  > a {
    > img {
      height: auto;
      width: ${(props) => (props.isMobile ? '100px' : '150px')};
      opacity: 0.8;
    }
  }

  /**
   * Em tablets / telas de baixa altura o rodapé é ocultado para liberar
   * espaço vertical à área de trabalho (desenho + tabela de itens).
   * Mantém-se coerente com --app-footer-h: 0px em global.js.
   */
  @media (max-width: 1440px), (max-height: 900px) {
    display: none;
  }
`;

export const MobileWrapper = styled.div`
  display: grid;
  grid-template-rows: 60px 1fr;

  width: 100%;
  height: 100vh;

  /**
   * PWA instalado na tela inicial: sem barra do navegador, o conteúdo
   * ocupa a tela toda e passaria por baixo do notch e da barra de status.
   * O recuo é aplicado só nesse modo, então a navegação pelo navegador
   * continua idêntica.
   *
   * 100svh (small viewport height) evita o corte causado pela barra
   * dinâmica no iOS; onde não houver suporte, vale o 100vh acima.
   */
  @media (display-mode: standalone), (display-mode: fullscreen) {
    height: 100svh;
    padding-top: var(--safe-top, 0px);
    padding-bottom: var(--safe-bottom, 0px);
    padding-left: var(--safe-left, 0px);
    padding-right: var(--safe-right, 0px);
  }
`;

export const MobileContent = styled.div`
  display: grid;
  grid-template-rows: 1fr 60px;
  box-shadow: ${(props) => `inset 0 0 1em ${props.theme.boxShadow}`};
  background: ${(props) => props.theme.background};

  width: 100%;
  height: 100%;

  ::-webkit-scrollbar {
    display: none;
  }

  ${(props) =>
    props.withPadding &&
    css`
      padding: 5px;
    `}
`;

export const MobileFooter = styled.footer`
  display: flex;
  padding: 10px;
  align-items: center;
  justify-content: center;
  height: 60px;

  background: ${(props) => props.theme.background};

  > a {
    > img {
      height: auto;
      width: 150px;
      opacity: 0.8;
    }
  }
`;
